import React from 'react';
import { Alert, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { sidebarAlertStyle } from './sidebar-alert-style';

export function RssSidebarAlert() {
  const { t } = useTranslation();

  return (
    <Box sx={sidebarAlertStyle}>
      <Alert severity="info">{t('editor.rss.limitation')}</Alert>
    </Box>
  );
}
